<template>
	<div class="item_sidebar border_item_sidebar active">
		<div class="wrapper_title">
			<div class="title">{{ title }}</div>
			<info-icon>
				<div style="max-width: 250px">
					<p><b>Data type:</b> Specify the data type that will be collected by this field.</p>
					<p><b>Data name:</b> A custom metadata name to store the field value in, only letters, digits and _ allowed.</p>
				</div>
			</info-icon>
		</div>
		<div class="wrapper_body wrapper_body_block">
			<div class="item">
					<div class="title">Is required?</div>

					<label class="switch_checkbox_item">
						<input type="checkbox" :disabled="isEmail" :checked="localData.required || isEmail"
						       @change="updatedData($event.target.checked, 'required')">
						<div class="switch_checkbox"><span></span></div>
					</label>
			</div>

			<div class="item" v-if="inputType!=='radio' && inputType!=='checkbox'">
				<div class="title">Show label?</div>
				<label class="switch_checkbox_item">
					<input type="checkbox" :checked="localData.showLabel"
					       @change="updatedData($event.target.checked, 'showLabel')">
					<div class="switch_checkbox"><span></span></div>
				</label>
			</div>

			<div class="item">
				<div class="title" >Data type</div>
				<v-select class="small" :options="dataOptions"
				          v-model="localData.dataType"
				          @input="updatedData($event, 'dataType')"
				          label="text"
				          :reduce="x=>x.id"
				          :searchable="true"
				          :clearable="true"
				          append-to-body />
			</div>
			<div class="item" v-if="localData.dataType==='email'">
					<div class="title layout-row flex-center">
						<span>Auto-optin?</span>
						<info-icon>
							Automatically opts-in your customers as they type-in their email address.
						</info-icon>
					</div>
				<label class="switch_checkbox_item">
					<input type="checkbox" :checked="localData.auto_optin"
					       @change="updatedData($event.target.checked, 'auto_optin')">
					<div class="switch_checkbox"><span></span></div>
				</label>
			</div>
			<div class="item" v-if="localData.dataType==='custom'">
				<div class="title">Data name</div>
				<input-field required v-model="localData.dataName" @input="updatedData($event, 'dataName')" small />
			</div>
			<div class="item">
				<div class="title">Placeholder</div>
				<input-field v-model="localData.placeholder" @input="updatedData($event, 'placeholder')" small />
			</div>

			<div class="item" v-if="inputType==='double'">
				<div class="title" >Data type #2 </div>
				<v-select class="small" :options="dataOptions"
				          autocomplete="off"
				          v-model="localData.dataType2"
				          @input="updatedData($event, 'dataType2')"
				          label="text"
				          :reduce="x=>x.id"
				          :searchable="true"
				          :clearable="true"
				          append-to-body />
			</div>

			<div class="item" v-if="inputType==='double' && localData.dataType2==='custom'">
				<div class="title">Data name #2</div>
				<input-field required v-model="localData.dataName2" @input="updatedData($event, 'dataName2')" small />
			</div>

			<div class="item" v-if="inputType==='double'">
				<div class="title">Placeholder #2</div>
				<input-field v-model="localData.placeholder2" @input="updatedData($event, 'placeholder2')" small />
			</div>

			<div class="item " v-if="inputType==='radio' || inputType==='checkbox'">
				<div class="title">Value</div>
				<input-field v-model="localData.value" @input="updatedData($event, 'value')" small />
			</div>

			<div class="item " v-if="inputType==='select'">
				<div class="title">Options</div>
				<v-select class="small" :options="options"
				          autocomplete="sdfksmdfkmkmkmkmkmkmx"
				          v-model="localData.optionsType"
				          @input="updatedData($event, 'optionsType')"
				          label="label"
				          :reduce="x=>x.id"
				          :searchable="false"
				          :clearable="false"
				          append-to-body />
			</div>
			<div  v-if="inputType==='select' && localData.optionsType==='states'" class="__province-note">
				<div class="alert_box blue">
					<inline-svg class="icon" :src="require('@/assets/img/info_icon.svg')" />
					<p class="no-padding">The Province/State box will be hidden for countries that do not need it.</p>
				</div>
			</div>
		</div>

		<div class="layout-column options-panel" v-if="localData.optionsType==='custom'">
			<div class="headline">Options</div>

			<div class="layout-row op-header">
				<span class="flex">Name</span>
				<span class="flex">Value</span>
			</div>
			<div v-for="(x, index) in localData.options" :key="index" class="layout-row flex-center option">
				<input-field class="flex" v-model="x.name" small placeholder="eg. GB, US, DE..."
				             @input="updatedData(localData.options, 'options')" />
				<span>:</span>
				<input-field class="flex" v-model="x.value" small placeholder="eg. United Kingdom"
				             @input="updatedData(localData.options, 'options')" />

				<a @click="removeOption(index)" class="panel_item_btn delete_btn">
					<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
				</a>
			</div>

			<v-button class="add-option" border label="Add option" slim @click="addOption" />
		</div>

	</div>
</template>

<script>
import InputField from "@/components/base/input-field";
import InfoIcon from "@/components/base/info-icon";
import VButton from "@/components/base/v-button";
import debounceAction from "@/helpers/debounce";
import VSwitch from '@/components/base/v-switch'

export default {
	name: 'FormElementProps',
	props: ['title', 'value', 'content'],
	components: {
		VSwitch,
		VButton,
		InfoIcon,
		InputField
	},
	data: function () {
		return {
			localData: {
				optionsType: 'countries',
				options: [],
				required: true,
				showLabel: true,
				dataType: '',
				dataType2: '',
				placeholder: '',
				placeholder2: '',
				value: '',
			},
			options:[
				{id:"countries", label:"All countries"},
				{id:"states", label:"Dynamic provinces/states"},
				// not practical
				// {id:"cities", label:"Dynamic cities"},
				{id:"custom", label:"Custom"},
			],
			dataOptions: [
				{ id: "", text: "Not Set" },
				{ id: "full_name", text: "Full Name" }, { id: "first_name", text: "First Name" },
				{ id: "last_name", text: "Last Name" }, { id: "email", text: "Email Address" },
				{ id: "phone", text: "Phone Number" },
				// billing address
				{ id: "address", text: "Billing Address" },
				{ id: "city", text: "Billing City" }, { id: "state", text: "Billing State" },
				{ id: "country", text: "Billing Country" }, { id: "zip", text: "Billing Zip" },

				// shipping address
				{ id: "shipping_address", text: "Shipping Address" },
				{ id: "shipping_city", text: "Shipping City" }, { id: "shipping_state", text: "Shipping State" },
				{ id: "shipping_country", text: "Shipping Country" }, { id: "shipping_zip", text: "Shipping Zip" },

				// other fields
				{ id: "vat", text: "VAT Number" }, { id: "custom", text: "Custom" } ],
		}
	},
	computed: {
		isEmail() {
			return this.localData.dataType==='email' || (this.inputType==='double' && this.localData.dataType2==='email');
		},
		inputType(){
			return this.content.attributes && this.content.attributes.basic ? this.content.attributes.basic.inputType : '';
		}
	},
	methods: {
		addOption() {
			if (!this.localData.options) this.localData.options = [];
			this.localData.options.push({name:"", value:""});
			this.updatedData("options", this.localData.options)
		},
		removeOption(index) {
			if (!this.localData.options) this.localData.options = [];
			this.localData.options.splice(index, 1);
			this.updatedData("options", this.localData.options)
		},
		updatedData: debounceAction(function (val, fieldName) {
			if (fieldName==='optionsType' && val!=='custom') {
				this.localData.options.splice(0, this.localData.options.length); // reset options to avoid storing them unnecessarily.
			}
			if ((fieldName==='dataType' && val==='email') || (this.inputType==="double" && fieldName==='dataType2' && val==='email')) {
				this.$set(this.localData, 'required', true);
			}
			this.$set(this.localData, fieldName, val);
			// this.localData[fieldName] = val;
			this.$emit('updated', this.localData);
		}, 500),
	},
	created() {
		if (this.value !== '') {
			this.localData = JSON.parse(JSON.stringify(this.value));
		}
	}
}
</script>
<style lang="scss" scoped>
.__province-note {
	margin: 10px 0 0;

	.alert_box {
		padding: 5px 10px;
		.icon {
			width: 22px;
			height: 22px;
			min-width: 22px;
			margin-right: 10px;
		}
		p {
			padding: 0;
			margin: 0;
			font-size: 12px;
		}
	}
}
.options-panel {
	margin-top: 10px;
	border: 1px dashed silver;
	border-radius: 5px;
	padding: 8px 3px;

	.item {
		display: flex;
		flex-direction: row;
	}
	.headline {
		text-align: center;
		font-weight: bold;
		font-size: 13px;
		color: $grey;
		margin-bottom: 4px;
	}
	.op-header {
		margin: 5px 0;
		span {
			margin-left: 5px;
		}
	}
	.option {
		margin-bottom: 5px;
		.input-field:first-child {
			max-width: 100px;
		}
	}
	.add-option {
		margin: auto;
	}
	.delete_btn {
		min-width: 28px;
		min-height: 28px;
		width: 28px;
		height: 28px;
		border-radius: 5px;
	}
}
.title {
	width: 110px;
	white-space: nowrap;
}
.v-select, .input-field {
	width: 100%;
}
</style>
